'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var utils = require('../utils');

var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0) return ch32(x, y, z);
  if (s === 1 || s === 3) return p32(x, y, z);
  if (s === 2) return maj32(x, y, z);
}

exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return x & y ^ ~x & z;
}

exports.ch32 = ch32;

function maj32(x, y, z) {
  return x & y ^ x & z ^ y & z;
}

exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}

exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}

exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}

exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}

exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}

exports.g1_256 = g1_256;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(rotr32, "rotr32", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(ft_1, "ft_1", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(ch32, "ch32", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(maj32, "maj32", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(p32, "p32", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(s0_256, "s0_256", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(s1_256, "s1_256", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(g0_256, "g0_256", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
  reactHotLoader.register(g1_256, "g1_256", "/home/yatham/Dev_BHS_Portal/node_modules/hash.js/lib/hash/sha/common.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();